import { render, staticRenderFns } from "./RegisterChargerAndCreateSiteDialog.vue?vue&type=template&id=385917c0&lang=pug&"
import script from "./RegisterChargerAndCreateSiteDialog.vue?vue&type=script&lang=ts&"
export * from "./RegisterChargerAndCreateSiteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports